export const MessageBoard_zh = {
    message:{
        backstage:"留言板后台",
        messageBoard:"留言板",
        message:"我要留言",
        said:"说点什么...",
        publish:"发表",
        building:"楼",
        reply:"回复",
        determine:"确定",
        cancel:"取消",
        help:"本页面对您是否有帮助?",
        said1:"我也说一句...",
        todayMessage:"今日留言数",
        processedMessage:"已处理留言数",
        unprocessedMessage:"未处理留言数",
        historyChart:"留言每日历史图表",
        unprocessedTabel:"未处理留言列表",
        num:"编号",
        userDate:"日期",
        userName:"用户名",
        msgPage:"留言页面",
        userMsg:"留言内容",
        operation:"操作",
        inputContent:"输入内容",
        submitReply:"提交回复",
        processedTabel:"已处理留言列表",
        responDate:"回复时间",
        responser:"回复人",
        respon:"回复内容",
        unread:"未读留言标签",
        unreadTabel:"未读留言列表",
        submissionTime:"提交时间",
        submittedTabel:"已提交留言列表",
    }
}
export const MessageBoard_en = {
    message:{
        backstage:"Message board backstage",
        messageBoard:"Message board",
        message:"I'd like to leave a message.",
        said:"Say something...",
        publish:"publish",
        building:"layer",
        determine:"determine",
        cancel:"cancel",
        help:"This page is helpful to you?",
        said1:"Let me say something...",
        reply:"reply",
        todayMessage:"Number of messages today",
        processedMessage:"Number of messages processed",
        unprocessedMessage:"Number of unprocessed messages",
        historyChart:"Comment daily history chart",
        unprocessedTabel:"The message list is not processed",
        num:"number",
        userDate:"date",
        userName:"User name",
        msgPage:"Message page",
        userMsg:"Message content",
        operation:"operation",
        inputContent:"Input content",
        submitReply:"Submit a reply",
        processedTabel:"The message list has been processed",
        responDate:"Recovery time",
        responser:"responder",
        respon:"Reply content",
        unread:"Unread message label",
        unreadTabel:"List of unread messages",
        submissionTime:"Submission time",
        submittedTabel:"A list of comments has been submitted",
       
    }
}